import { MapTo } from '@adobe/aem-react-editable-components';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { withTranslation } from '@yme/services/i18n';
import { ReturnForm } from './ReturnForm';
import { isReturnFormEmpty } from './helpers';
const returnFormEditConfig = {
    emptyLabel: 'Return Form',
    isEmpty: isReturnFormEmpty,
};
export default MapTo(AEM_FUNCTIONS.returnForm)(withTranslation(ReturnForm, [
    'formType.labels',
    'yourOrder.labels',
    'yourParcel.labels',
    'selectItems.labels',
    'shippingLabel.labels',
    'successPageModel.labels',
    'errorPageModel.labels',
]), returnFormEditConfig);
